import ky from 'ky';

export const getValidUrl = async (websiteURL, loadingCallback) => {
	const controller = new AbortController();
	const { signal } = controller;
	const formData = new FormData();
	formData.append('websiteURL', websiteURL);
	formData.append('method', 'getValidURL');
	loadingCallback(true);
	try {
		const res = await ky
			.post('/global/components/links.cfc', {
				body:    formData,
				signal,
				retry:   2,
				timeout: 30000,
			})
			.json();
		loadingCallback(false);
		return res;
	} catch (error) {
		loadingCallback(false);
		return error;
	}
};

export const getDollarFormatLabel = (price) => {
	if (price > 0) {
		return `$${new Intl.NumberFormat('en-US').format(price)}`;
	}
	return 'not available';
};

export const minMaxPricesOptionsArray = (field) => {
	const noMin = { value: 0, label: 'No Min' };
	const noMax = { value: 99999999, label: 'No Max' };
	const priceList = [];
	const initialValue = field === 'min' ? noMin : noMax;
	priceList.push(initialValue);
	for (let price = 10000; price < 1000000; price += 10000) {
		priceList.push({ value: price, label: getDollarFormatLabel(price) });
	}
	for (let price = 1000000; price <= 10000000; price += 1000000) {
		priceList.push({ value: price, label: getDollarFormatLabel(price) });
	}
	return priceList;
};

export const formatPhoneNumber = (phoneNumber) => {
	if (!phoneNumber) {
		return;
	}

	let cleaned = phoneNumber.replace(/\D/g, '');

	const isValid = /^1?\d{10}$/.test(cleaned);

	if (!isValid) {
		return phoneNumber;
	}

	// It will remove 1 from already saved US phone number
	if (
		phoneNumber.toString().length === 11 &&
		phoneNumber.toString().charAt(0) === '1'
	) {
		cleaned = cleaned.substring(1);
	}

	const formatted = cleaned.replace(/^1?(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');

	let number = phoneNumber;

	if (cleaned.toString().length === 10) {
		number = `+1 ${formatted}`;
	}

	return number;
};
